import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";

const S10 = (props) => {
    const radio = useRadioInput({
        name: "sale[discovery][date]", label: "Når ble du først oppmerksom på problemet?",
        options: {
            data: [
                { label: "Null til fire uker etter overtakelse", value: "u0-4" },
                { label: "Én til to måneder etter overtakelse", value: "m1-2" },
                { label: "To til seks måneder etter overtakelse", value: "m2-6" },
                { label: "Mer enn seks måneder etter overtakelse", value: "m6+" },
            ],
        },
        ...props,
    })

    return (
        <Wrapper {...props} header="Fortell oss om problemstillingen">
            <RadioInput {...radio.props}/>
        </Wrapper>
    );
};

export default S10;
